<template>
  <div class="main-log">
    <div
      class="log-wrapper"
      @mouseenter="showTable = true"
      @mouseleave="showTable = false"
      v-if="false"
    >
      <span><img class="log-icon" src="/img/tasks/clock.svg"/></span>

      <div
        v-if="showTable && task.log.length > 0"
        class="log-table"
        @mouseenter="showTable = false"
      >
        <div class="table-responsive">
          <table class="table">
            <tbody>
              <tr v-for="(item, idx) in task.log" :key="item.id">
                <td v-if="idx < 7">
                  {{ item.status_type ? item.status_type.title : "" }}
                </td>
                <td v-if="idx < 7">{{ formatDateTable(item.created_at) }}</td>
                <td v-if="idx < 7">{{ item.created_at | shortTime }}</td>
                <td v-if="idx < 7">{{ item.user.full_name }}</td>
                <td v-if="idx < 7">{{ formatDateTable(item.updated_at) }}</td>
                <td v-if="idx < 7">{{ item.updated_at | shortTime }}</td>
                <td
                  v-if="idx < 7"
                  :title="item.content ? removeHtml(item.content) : ''"
                >
                  {{
                    item.content ? removeHtml(item.content) : "" | truncate(20)
                  }}
                </td>
                <td v-if="idx < 7">
                  {{ item.time_quantity ? item.time_quantity : 0 }}
                </td>
                <td v-if="idx < 7">
                  {{ item.priority_type ? item.priority_type.title : "" }}
                </td>
                <!--                <td v-if="idx < 7">-->
                <!--                  {{ item.task_type ? item.task_type.title : "" }}-->
                <!--                </td>-->
                <!--<td v-if="idx < 7">{{ item.to_user.full_name }}</td>-->

                <td v-if="idx < 7">{{ item.due_date | shortTime }}</td>
                <td v-if="idx < 7">{{ item.comments }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="log-wrapper-view"
      v-if="
        CheckUserPermission([1, 2, 12]) || auth.user.id === getOriginalCreator()
      "
      @mouseenter="
        [
          countUserView(),
          taskViewsLogArr.length > 0
            ? (showTaskCountLogTable = true)
            : (showTaskCountLogTable = false)
        ]
      "
      @mouseleave="showTaskCountLogTable = false"
    >
      <div class="eye-div">
        <!--      <div class="eye-div" v-if="taskViewsLogArr.length > 0">-->
        <span
          class="fas fa-eye eye-count-icon"
          :class="{ 'eye-count-icon-white': taskViewsLogArr.length === 0 }"
        ></span>
        <span class="eye-counter" v-if="taskViewsLogArr.length > 0">{{
          taskViewsLogArr.length
        }}</span>
      </div>
      <div
        v-if="showTaskCountLogTable && taskViewsLogArr.length > 0"
        class="log-table-views"
      >
        <div class="table-responsive mrb2">
          <div>
            <table class="table mrb2">
              <tbody>
                <tr v-for="item in latestSeven" :key="item.id">
                  <td>{{ formatDateTable(item.updated_at) }}</td>
                  <td>{{ item.updated_at | shortTime }}</td>
                  <td>{{ item.user.full_name }}</td>
                </tr>
              </tbody>
              <button
                v-if="taskViewsLogArr.length > 6"
                @click="showHistory = !showHistory"
                class="history-btn"
              >
                {{ showHistory ? "Close" : "Expand" }}
              </button>
            </table>
          </div>
          <div v-if="showHistory">
            <div class="table-history">
              <table class="table ">
                <tbody>
                  <tr v-for="item in taskViewsLogArr" :key="item.id">
                    <td>{{ formatDateTable(item.updated_at) }}</td>
                    <td>{{ item.updated_at | shortTime }}</td>
                    <td>{{ item.user.full_name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import apiClientCreator from "../../../helpers/api/request";
import {mapGetters, mapState} from "vuex";
import UsersPermissionCheck from "../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "TaskLog",
  mixins: [UsersPermissionCheck],
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
  },
  data() {
    return {
      showTable: false,
      showTaskCountLogTable: false,
      taskViewsLogArr: this.task.task_view_log,
      latestSeven: [],
      showHistory: false
      // viewsLength:this.task.task_view_log.length
    };
  },
  methods: {
    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, " ");
    },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY ");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY");
    },

    countUserView() {
      this.showTaskCountLogTable = true;
      let apiClient = apiClientCreator(
        `tasks/stats/views_count/${this.task.id}`
      );
      apiClient.get("").then(res => {
        this.latestSeven = res.data.latestSeven;
        this.taskViewsLogArr = res.data.all;
      });
    },

    getOriginalCreator() {
      let originalCreator = null;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === assign.assigned_by.id) {
          originalCreator = assign.assigned_by.id;
        }
      });

      return originalCreator;
    }
  }
};
</script>

<style scoped>
.main-log {
  display: flex;
}
.eye-div {
  display: flex;
}
.eye-count-icon {
  margin-top: 5px;
  margin-left: 8px;
  font-size: 16px;
}
.eye-counter {
  margin-top: -2px;

  font-family: Montserrat !important;
  margin-left: 1px;
  font-weight: 600;
  font-size: 11px;
}
.eye-count-icon-white {
  color: rgba(99, 79, 79, 0.25);
}
.log-icon {
  width: 23px;
  cursor: pointer;
}
.log-wrapper {
  display: inline;
  position: relative;
}
.log-wrapper-view {
  display: inline;
  position: relative;
}
.log-table {
  position: absolute;
  top: 24px;
  right: 0;
  width: max-content;
  z-index: 10001;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.log-table-views {
  position: absolute;
  top: 24px;
  right: 0;
  z-index: 10000;
  width: max-content;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: "Montserrat" !important;
  font-size: 12px;
}
.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}
.history-btn {
  font-family: Montserrat;
  height: 20px;
  background: #44a2d2;
  color: white;
  border: 0;
  padding: 5px;
  font-size: 10px;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 2px;
  margin-bottom: 5px;
  line-height: 10px;
}
.table-history {
  max-height: 150px;
  overflow-y: scroll;
}
.badge-primary {
  background-color: #0d6aad;
  margin-left: 3px;
}

.mrb2 {
  margin-bottom: 2px;
}
</style>
